import React from 'react';
import Rating from '../../UI/Rating/Rating';

export const renderSlides = (asset, slides) =>
  slides.map((slide) => (
    <div className="c-featured-reviews__slide">
      <div className="c-featured-reviews__slide-rating">
        <Rating {...slide.rating} starsAssetUrl={asset} />
      </div>
      <div className="c-featured-reviews__slide-quote h4-roobert color-gray">
        <h4>{slide.quote}</h4>
      </div>
      <div className="c-featured-reviews__slide-attribute eyebrow-1 color-gray">
        <p>{slide.attribute}</p>
      </div>
    </div>
  ));
